export default __webpack_public_path__ + "static/media/nav_logo.7ad3157f.png";